import PropTypes from 'prop-types'
import React,{useEffect, useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu
} from "reactstrap"
import "chartist/dist/scss/chartist.scss";

import { useSelector } from 'react-redux';
import store from 'store';
import { SET_CODE } from 'store/auth/data/actionTypes';

import Emitter from './Emitter';
// import Emitter from './Emitter_v2';
// import Collection from './Collection';
import Collection from './Collection_v2';
import Driver from './Driver';
// import Treatment from './Treatment';
import Treatment from './Treatment_v2';
import Demand from './Demand';

import { getCode } from 'crud/auth.crud';

const Dashboard = props => {
  const selector = useSelector(state => state)

  const [type, setType] = useState(selector.auth.user?.type || "")

  useEffect(async()=>{
    const response = await getCode()
    store.dispatch({ type: SET_CODE, data: [response.data]})
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>홈 | 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          {/* 
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title font-size-24">관리 홈</h6>
                <ol className="breadcrumb m-0">
                  <li className="font-size-16" style={{color : '#8A8A8A'}}>'국내최초' 음식물류 폐기물 스마트 수거 플랫폼</li>
                </ol>
              </Col>
            </Row>
          </div> 
          */}
          <div style={{marginBottom: 30}}></div>

          { type === 'emitter' && <Emitter/> }
          { type === 'collection' && <Collection/> }
          { type === 'driver' && <Driver/> }
          { type === 'treatment' && <Treatment/> }
          { type === 'demand' && <Demand/> }

        </Container>
      </div>
    </React.Fragment>
  )
}

export default Dashboard
